import { css, React, reduxConnect, styled } from '../lib/imports';
import { Image, Spacing, SubmitButton, Text, ToggleSwitch } from '../components';
import { sendNotificationStatus } from './actions';
import { useCdnUrl } from '../app/context/config';
import { useState } from 'react';
import { fireMessageEvent } from '../messenger/utils';
import { analyticActionMap } from '../analytics/utils';

const containerBaseStyles = ({ theme }) => css`
  padding-top: ${theme.spacings.tera};
  margin-left: ${theme.spacings.peta};
  margin-right: ${theme.spacings.peta};
`;

const Container = styled('div')(containerBaseStyles);

const switchWrapperBaseStyles = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled('div')(switchWrapperBaseStyles);

const reminderSwitchBaseStyles = ({ theme }) => css`
  margin-right: ${theme.spacings.kilo};
`;

const ReminderSwitch = styled('div')(reminderSwitchBaseStyles);

const Notification = ({ header, body, text, buttonText, handleToggleSubmission, ...props }) => {
  const [isActive, setActive] = useState(false);
  const [reminderHasUpdated, setReminderHasUpdated] = useState(false);
  const cdnUrl = useCdnUrl();
  const { config, currentRoute } = props;
  const { platform, env } = config;

  const { clickedType, path, toggleType, onValue, offValue, notifications } = analyticActionMap;

  const submitNotificationStatus = () => {
    handleToggleSubmission(isActive, reminderHasUpdated);
  };
  if (reminderHasUpdated) {
    fireMessageEvent({
      title: clickedType,
      data: {
        platform,
        env,
        path: path,
        modal: notifications,
        element: toggleType,
        element_name: `${analyticActionMap[currentRoute]}_${notifications}_${isActive ? onValue : offValue}`,
        element_action: isActive ? onValue : offValue,
      },
    });
  }

  return (
    <Container>
      <Text lineHeight='22px' size='zetta' bold centered>
        {header}
      </Text>
      <Spacing paddingTop='giga'>
        <Text as='span' size='giga' noMargin centered>
          {body}
        </Text>
      </Spacing>
      <Spacing paddingBottom='giga' paddingTop='giga'>
        <Image src={`${cdnUrl}notification.png`} naturalSize />
      </Spacing>
      <Spacing paddingBottom='yotta' paddingTop='giga'>
        <Wrapper>
          <ReminderSwitch
            onClick={() => {
              setReminderHasUpdated(true);
              setActive(!isActive);
            }}
          >
            <ToggleSwitch isActive={isActive} />
          </ReminderSwitch>
          <Text size='mega' noMargin>
            {text}
          </Text>
        </Wrapper>
      </Spacing>
      <SubmitButton variant='primary' text={buttonText} stretch onSelect={submitNotificationStatus} />
    </Container>
  );
};

const mapStateToProps = (state) => {
  const { strings } = state;

  const allStrings = {
    header: strings['notifications/reminders/header'],
    body: strings['notifications/reminders/body'],
    text: strings['notifications/reminders/text'],
    buttonText: strings['notifications/reminders/button'],
  };

  return {
    ...allStrings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleToggleSubmission: (status) => dispatch(sendNotificationStatus(status)),
  };
};

export default reduxConnect(mapStateToProps, mapDispatchToProps)(Notification);
